import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getReports } from "../../actions/report.jsx";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
const { RangePicker } = DatePicker;
const { Option } = Select;
class Reports extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",
    ds: null,
    de: null,
    client: null,
    status: "",
    report: null,
    invalid_code: null,
    p: null,
    current: 1,
  };
  componentDidMount = async () => {
    const res = await this.props.getReports(
      this.state.ds,
      this.state.de,
      this.state.client,
      this.state.status,
      this.state.report,
      this.state.invalid_code,
      this.state.p
    );
    this.setState({ data: res });
  };
  handleStatus = async (user, active) => {
    const code = await this.props.updateAuth(user, active);
    if (code === 201) {
      const res = await this.props.getUsers();
      this.setState({ data: res });
    }
  };
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    report_id,
    product_name,
    scan_code,
    invalid_code,
    client,
    status,
    created_at,
    action
  ) => {
    return {
      sl,
      report_id,
      product_name,
      scan_code,
      invalid_code,
      client,
      status,
      created_at,
      action,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getUsers();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (id) => {
    history.push(`/report-details?id=${id}`);
  };
  handleEditModalVisible = (user_id) => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      id: user_id,
    });
  };
  onClosePass = () => {
    this.setState({
      passVisible: false,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };
  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getReports(
      page,
      this.state.client,
      this.state.status,
      this.state.report,
      this.state.invalid_code,
      this.state.ds,
      this.state.de
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getReports(
      this.state.p,
      this.state.client,
      this.state.status,
      this.state.report,
      this.state.invalid_code,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "Report ID",
        dataIndex: "report_id",
        key: "report_id",
        width: "15%",
        ...this.getColumnSearchProps("report_id"),
      },
      {
        title: "Product Name",
        dataIndex: "product_name",
        key: "product_name",
        width: "15%",
        ...this.getColumnSearchProps("product_name"),
      },
      {
        title: "Scan Code",
        dataIndex: "scan_code",
        key: "scan_code",
        width: "25%",
      },
      {
        title: "Is Invalid",
        dataIndex: "invalid_code",
        key: "invalid_code",
        width: "15%",
        ...this.getColumnSearchProps("invalid_code"),
      },

      {
        title: "User",
        dataIndex: "client",
        key: "client",
        width: "30%",
        ...this.getColumnSearchProps("client"),
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "10%",
        ...this.getColumnSearchProps("status"),
      },

      {
        title: "Created Date",
        dataIndex: "created_at",
        key: "created_at",
        width: "20%",
        ...this.getColumnSearchProps("created_at"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: "25%",
      },
    ];
    const { data } = this.state;
    const rows = [
      data?.report
        ? data?.report.map((item, id) =>
            this.createData(
              id + 1,
              item.report_id,
              item.product_name,
              item.scan_code,
              item.invalid_code ? (
                <Tag color="#e29135">Invalid</Tag>
              ) : (
                <Tag color="#78d81d">Valid</Tag>
              ),
              <>
                <p>Mobile: {item?.app_user?.mobile_number}</p>
                <p>Address: {item?.address}</p>
              </>,
              item.status ? (
                <Tag color="#bde235">Active</Tag>
              ) : (
                <Tag color="#6fcf20">Done</Tag>
              ),
              this.makeLocalTime(item.created_at),
              <>
                <Button
                  size="small"
                  type="primary"
                  icon={<EyeOutlined />}
                  onClick={() => this.handleVisible(item.report_id)}
                >
                  View
                </Button>{" "}
                &nbsp;
              </>
            )
          )
        : "",
    ];
    return (
      <Content>
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Report List</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Report List"
          subTitle="Report Management"
          extra={
            <Tag color="#2db7f5" style={{ fontSize: "15px", padding: "4px" }}>
              {" "}
              {data?.count} reports found
            </Tag>
          }
        ></PageHeader>
        <Row gutter={16}>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Client Email"
              allowClear
              style={{ width: "99%" }}
              onChange={(e) => this.setState({ client: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Report"
              allowClear
              style={{ width: "99%" }}
              onChange={(e) => this.setState({ report: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select one"
              name="invalid_code"
              optionFilterProp="children"
              onChange={(e) => this.setState({ invalid_code: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="valid">Valid</Option>
              <Option value="invalid">Invalid</Option>
            </Select>
          </Col>
          <br />
          <br />
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ status: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="active">Active</Option>
              <Option value="done">Done</Option>
            </Select>
          </Col>
          <br />
          <br />

          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <RangePicker
              onChange={this.handleDate}
              format="YYYY/MM/DD"
              style={{ width: "80%" }}
            />
            &nbsp; &nbsp;
            <Tooltip title="search" onClick={this.handleApiSearch}>
              <Button type="primary" shape="circle" icon={<SearchOutlined />} />
            </Tooltip>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          defaultCurrent={1}
          total={data?.count}
          pageSize={20}
          style={{ textAlign: "right", paddingRight: "100px" }}
          onChange={(page) => this.handlePageChange(page)}
        />
      </Content>
    );
  }
}

export default connect(null, { getReports })(Reports);
